/**
 * SearchBox component for the microreceipt frontend.
 *
 * @module SearchBox
 * @returns {JSX.Element} The SearchBox component.
 */
import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const SearchBox = () => {
  const [keyword, setKeyword] = useState('')

  const navigate = useNavigate()

  const submitHandler = (e) => {
    e.preventDefault()
    if (keyword.trim()) {
      navigate(`/search/${keyword}`)
    } else {
      setKeyword('')
      navigate('/receipts')
    }
  }

  return (
    <Form className='d-flex' onSubmit={submitHandler}>
      <Form.Control
        type='text'
        name='q'
        onChange={(e) => setKeyword(e.target.value)}
        placeholder='DDMMYYYY'
        className='mr-sm-2 ml-sm-5'
      />
      <Button type='submit' variant='info' className='p-2'>
        Search
      </Button>
    </Form>
  )
}

export default SearchBox
